import './ApiKeysTableComponent.scss';
import { Component } from 'react';
import { Button } from 'app/components/Basics/'
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import { Table, GenericCell } from '@ecosystem/ui-lib/core/components/Table';
import { DateTime } from "luxon";
import Modal from 'app/components/Modal';
import { ReactComponent as EditPen } from 'app/assets/icons/edit-pen.svg';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import newAwsApiKey from '../../../models/awsapikeys';
import { ApiKeysContext } from '../ApiKeysContext';
import ValidateApiKey from '../ApiKeyValidation';
import ApiKeyForm from '../ApiKeyForm/ApiKeyFormComponent';

class ApiKeysTableComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showApiKeyFormModal: false,
            selectedApiKey: null
        }
    }

    addApiKeyRow(apiKey) {
        const cols = [];
        var formatedCreatedAt = "";
        var formatedLastUsedAt = "";
        if (apiKey.createdAt) {
            const createdAt = DateTime.fromISO(apiKey.createdAt);
            formatedCreatedAt = createdAt.toFormat("dd/MM/yyyy HH:mm:ss");
        }
        if (apiKey.lastUsedAt) {
            const lastUsedAt = DateTime.fromISO(apiKey.lastUsedAt);
            formatedLastUsedAt = lastUsedAt.toFormat("dd/MM/yyyy HH:mm:ss");
        }
        cols.push(<GenericCell className="column-edit" primary={<EditPen className='edit-icon' onClick={(e) => { this.openFormModal(e, apiKey, true) }} />} />);
        cols.push(<GenericCell className="column-name" primary={<div>
            <div className="apikey-name">{apiKey.name}</div>
            <div className="apikey-createdat">{formatedCreatedAt}</div>
        </div>} />);
        cols.push(<GenericCell className="column-apikey-id" primary={apiKey.apiKeyId} />);
        cols.push(<GenericCell className="column-active" primary={apiKey.isActive ? "Yes" : "No"} />);
        cols.push(<GenericCell className="column-last-used-at" primary={formatedLastUsedAt} />);
        cols.push(<GenericCell className="column-description" primary={apiKey.description} />);
        cols.push(<GenericCell className="column-created-by" primary={apiKey.createdByUserName} />);
        cols.push(<GenericCell className="column-remove" primary={<div><ButtonIcon onClick={() => this.deleteApiKeyHandler(apiKey.apiKeyId)} icon={Icons.Close} /></div>} />);
        return cols;
    }

    closeFormModal() {
        this.setState({
            showApiKeyFormModal: false,
            selectedApiKey: null,
            originalSelectedApiKey: null,
            editExistingApiKey: null
        });
    }

    openFormModal(event, apiKey, editExistingApiKey) {
        let originalApiKey = cloneDeep(apiKey);
        this.setState({
            showApiKeyFormModal: true,
            editExistingApiKey: editExistingApiKey,
            selectedApiKey: cloneDeep(apiKey),
            originalSelectedApiKey: originalApiKey
        });
    }

    async saveApiKey() {
        if(this.state.editExistingApiKey){
            await this.context.updateApiKey(this.state.selectedApiKey);
        }
        else {
            const createdApiKey = await this.context.createApiKey(this.state.selectedApiKey);
            this.setState({
                createdApiKeyValue: createdApiKey.apiKeyValue,
            });
        }
        this.closeFormModal();
    }

    async hideApiKeyTextModal() {
        this.setState({ createdApiKeyValue: '' });
    }

    deleteApiKeyHandler(apiKeyId) {
        this.setState({
            deleteApiKeyModalText: `Are you sure you want to delete the api key with id '${apiKeyId}'?`,
            apiKeyToDelete: apiKeyId
        });
    }

    hideDeleteModal() {
        this.setState({ deleteApiKeyModalText: '', apiKeyToDelete: '' })
    }

    async confirmDelete() {
        await this.context.deleteApiKey(this.state.apiKeyToDelete);
        this.hideDeleteModal();
    }

    disableSave() {
        var errors = ValidateApiKey(this.state.selectedApiKey);
        if (errors.length > 0) {
            return true;
        }
        return isEqual(this.state.selectedApiKey, this.state.originalSelectedApiKey);
    }

    render() {
        const rows = [];
        if (this.props.apiKeys) {
            this.props.apiKeys.forEach((apiKey) => {
                rows.push(this.addApiKeyRow(apiKey));
            });
        }

        return (
            <div className="AppFormComponent ApiKeyTable">
                <div className="form-row">
                    <div className="form-row-left">
                    </div>
                    <div className="form-row-right">
                        <Button secondary icon={<PlusIcon />} onClick={() => this.openFormModal("", newAwsApiKey, false)}>Api Key</Button>
                    </div>
                </div>
                <Table
                    className="ApiKeysList"
                    columns={[
                        {
                            headerKey: `column-edit`,
                            className: "AppFormTableHeader column-edit",
                            name: ``
                        },
                        {
                            headerKey: `column-name`,
                            className: "AppFormTableHeader column-name",
                            name: `Name`
                        },
                        {
                            headerKey: `column-apikey-id`,
                            className: "AppFormTableHeader column-apikey-id",
                            name: `Id`
                        },
                        {
                            headerKey: `column-active`,
                            className: "AppFormTableHeader column-active",
                            name: `Active`
                        },
                        {
                            headerKey: `column-last-used-at`,
                            className: "AppFormTableHeader column-last-used-at",
                            name: `Last Used`
                        },
                        {
                            headerKey: `column-description`,
                            className: "AppFormTableHeader column-description",
                            name: `Description`
                        },
                        {
                            headerKey: `column-created-by`,
                            className: "AppFormTableHeader column-created-by",
                            name: `Created By`
                        },
                        {
                            headerKey: `column-delete`,
                            className: "AppFormTableHeader column-delete",
                            name: ``
                        }
                    ]}
                    rows={rows}
                    sortingOptions={{ headerKey: null }}
                    isHeaderSticky={false}
                    isFirstColumnSticky={false}
                />

                {this.state.showApiKeyFormModal && (<Modal size="fit-content" content={
                    <ApiKeyForm apiKey={this.state.selectedApiKey} editExistingApiKey={this.state.editExistingApiKey} />
                }
                    confirmButtonLabel="Save"
                    disableConfirmButton={this.disableSave()}
                    confirmModalHandler={this.saveApiKey.bind(this)}
                    cancelButtonLabel="Cancel"
                    cancelModalHandler={this.closeFormModal.bind(this)}
                />)
                }
                {this.state.deleteApiKeyModalText && (<Modal content={this.state.deleteApiKeyModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}
                {this.state.createdApiKeyValue && (<Modal content={
                        <span><strong>API KEY</strong>: <span style={{fontStyle: "italic"}}>{this.state.createdApiKeyValue}</span><br/>Once you close this dialog, you will <strong>not</strong> be able to retrieve it again. Please copy it now.</span>
                    } size="small" hideConfirmButton={true} cancelButtonLabel="Close" cancelModalHandler={this.hideApiKeyTextModal.bind(this)} />)}
            </div>
        );
    }
}
ApiKeysTableComponent.contextType = ApiKeysContext;
export default ApiKeysTableComponent;